import { getExtension, extensions } from './extensions';

// Use to resolve icon according to the file type
export default function resolveIcon(extension) {
  // icons list for possible file extension
  let icons = {
    zip: 'folder-zip-outline',
    excel: 'file-excel-outline',
    doc: 'file-word-outline',
    powerpoint: 'file-powerpoint-outline',
    access: 'microsoft-access',
    html: 'language-html5',
    text: 'text-shadow',
    audio: 'music',
    video: 'file-video-outline',
    pdf: 'file-pdf-box',
    img: 'file-image-outline',
    CHANNEL: 'account-multiple',
    ONE_ON_ONE: 'chat',
    GROUP: 'account-group',
    MEETING: 'calendar-month-outline'
  };
  // If extension exsist in our extensions
  // resolve else default file icon
  if (!(extension?.toLowerCase() in extensions())) {
    return 'mdi-file';
  } else {
    return 'mdi-' + icons[getExtension(extension.toLowerCase())];
  }
}
